import { featuredStories } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Stories() {
  return (
    <section id="stories" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Featured Stories"
          title="精选情感故事"
          description="每一篇都从一段具体的往事写起。它们并不轰烈，却可能在某一句里，让你想起自己的某个下午、某个人。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredStories.map((story) => (
            <article
              key={story.title}
              className="group flex flex-col bg-background-100 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={story.image}
                  alt={`${story.title}——长日光阴${story.tag}情感故事配图`}
                  title={`${story.title} · 长日光阴回忆录`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 font-label">
                    {story.tag}
                  </span>
                  <span>{story.date}</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">
                  {story.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {story.excerpt}
                </p>
                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line"></i>
                    阅读约 {story.readMin} 分钟
                  </span>
                  <span className="flex items-center gap-1 text-primary-700">
                    细品
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}